import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import HowItWorks from "@/pages/HowItWorks";
import Donate from "@/pages/Donate";
import DonorDashboard from "@/pages/DonorDashboard";
import HolderDashboard from "@/pages/HolderDashboard";
import Treasury from "@/pages/Treasury";
import CommunityWall from "@/pages/CommunityWall";
import AdminLogin from "@/pages/AdminLogin";
import AdminConsole from "@/pages/AdminConsole";

function Shell({ children }) {
  return (
    <div className="App">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Shell><Landing /></Shell>} />
          <Route path="/how" element={<Shell><HowItWorks /></Shell>} />
          <Route path="/donate" element={<Shell><Donate /></Shell>} />
          <Route path="/dashboard" element={<Shell><DonorDashboard /></Shell>} />
          <Route path="/holder" element={<Shell><HolderDashboard /></Shell>} />
          <Route path="/treasury" element={<Shell><Treasury /></Shell>} />
          <Route path="/wall" element={<Shell><CommunityWall /></Shell>} />
          <Route path="/admin" element={<Shell><AdminLogin /></Shell>} />
          <Route path="/admin/console" element={<Shell><AdminConsole /></Shell>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
